export class AppConsts {
    static readonly GrafanaConfigurationName = 'grafana';
    static readonly ApplicationName = 'Zendra';
}
